import actionCreatorFactory from 'typescript-fsa';
import { SystemStateMessage } from '../../../models/SystemStateMessage';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('systemStateMessage');

/**
 * システム状態メッセージ表示アクション
 */
const putMessage = actionCreator<SystemStateMessage>('PUT_MESSAGE');
/**
 * システム状態メッセージクリアアクション
 */
const reset = actionCreator('RESET');

export {
  putMessage,
  reset
};



// WEBPACK FOOTER //
// ./src/redux/modules/systemStateMessage/actions.ts